//import chroma from 'chroma-js';

const MBTILES_TILESERVER = 'https://maps.greenpeace.org/api/mbtiles/gpdk_nitrate';
export const MAPBOX_TOKEN = 'pk.eyJ1IjoiZ3JlZW5wZWFjZWdtaCIsImEiOiJja3BpNTdrcTQwMGFwMnVsajN1encyamE3In0.1qRAZvB6vqzMjrO_eGFLew';
export const DEFAULT_COORDS = [9.691148378333006, 55.85869951826262];
export const DEFAULT_ZOOM = 6;
export const DEFAULT_BASEMAP_STYLE = 'mapbox://styles/greenpeacegmh/cmgj4qnjl000501s6furpbvp2';

export const GSHEET_LANGUAGES = {
	id: '1F52IL3jhbUscWiI72DWD9PFza5z0hhWn_5BxuGC9zsY',
	sheet: 'UI'
};

//export const NITRATE_COLOR_SCALE = chroma.scale(['#88bb2f', '#ffd207', '#ff7b34', '#CC0000', '#520653']).domain([0,1]);
//export const NITRATE_COLOR_SCALE_COLORS = NITRATE_COLOR_SCALE.colors(20);

export const CONCENTRATION_LEVELS = [{
	id: 1,
	startValue: 0,
	endValue: 3.85,
	color: '#bad3fe',
	description: '',
	healthSentence: '',
	healthIcons: [],
}, {
	id: 2,
	startValue: 3.85,
	endValue: 6,
	color: '#bcb5da',
	description: '',
	healthSentence: '',
	healthIcons: ['cancer'],
}, {
	id: 3,
	startValue: 6,
	endValue: 9.25,
	color: '#be96b5',
	description: '',
	healthSentence: '',
	healthIcons: ['cancer'],
}, {
	id: 4,
	startValue: 9.25,
	endValue: 17,
	color: '#c07891',
	description: '',
	healthSentence: '',
	healthIcons: ['cancer'],
}, {
	id: 5,
	startValue: 17,
	endValue: 25,
	color: '#c2596d',
	description: '',
	healthSentence: '',
	healthIcons: ['cancer'],
}, {
	id: 6,
	startValue: 25,
	endValue: 30,
	color: '#c43b48',
	description: '',
	healthSentence: '',
	healthIcons: ['cancer','pregnancy','bluebaby'],
}, {
	id: 7,
	startValue: 30,
	endValue: 35,
	color: '#c71d24',
	description: '',
	healthSentence: '',
	healthIcons: ['cancer','pregnancy','bluebaby'],
}, {
	id: 8,
	startValue: 35,
	endValue: 40,
	color: '#ab1318',
	description: '',
	healthSentence: '',
	healthIcons: ['cancer','pregnancy','bluebaby'],
}, {
	id: 9,
	startValue: 40,
	endValue: 45,
	color: '#881014',
	description: '',
	healthSentence: '',
	healthIcons: ['cancer','pregnancy','bluebaby'],
}, {
	id: 10,
	startValue: 45,
	endValue: 99,
	color: '#640d0f',
	description: '',
	healthSentence: '',
	healthIcons: ['cancer','pregnancy','bluebaby'],
}];

export const LEGEND_CONTENT = [
	{color: CONCENTRATION_LEVELS[0].color},
	{color: CONCENTRATION_LEVELS[1].color},
	{color: CONCENTRATION_LEVELS[2].color},
	{color: CONCENTRATION_LEVELS[3].color},
	{color: CONCENTRATION_LEVELS[4].color},
	{color: CONCENTRATION_LEVELS[5].color},
	{color: CONCENTRATION_LEVELS[6].color},
	{color: CONCENTRATION_LEVELS[7].color},
	{color: CONCENTRATION_LEVELS[8].color},
	{color: CONCENTRATION_LEVELS[9].color}
];

/*
export const LEGEND_CONTENT = [
	{color: NITRATE_COLOR_SCALE_COLORS[0]},
	{color: NITRATE_COLOR_SCALE_COLORS[1]},
	{color: NITRATE_COLOR_SCALE_COLORS[2]},
	{color: NITRATE_COLOR_SCALE_COLORS[3]},
	{color: NITRATE_COLOR_SCALE_COLORS[4]},
	{color: NITRATE_COLOR_SCALE_COLORS[5]},
	{color: NITRATE_COLOR_SCALE_COLORS[6]},
	{color: NITRATE_COLOR_SCALE_COLORS[7]},
	{color: NITRATE_COLOR_SCALE_COLORS[8]},
	{color: NITRATE_COLOR_SCALE_COLORS[9]},
	{color: NITRATE_COLOR_SCALE_COLORS[10]},
	{color: NITRATE_COLOR_SCALE_COLORS[11]},
	{color: NITRATE_COLOR_SCALE_COLORS[12]},
	{color: NITRATE_COLOR_SCALE_COLORS[13]},
	{color: NITRATE_COLOR_SCALE_COLORS[14]},
	{color: NITRATE_COLOR_SCALE_COLORS[15]},
	{color: NITRATE_COLOR_SCALE_COLORS[16]},
	{color: NITRATE_COLOR_SCALE_COLORS[17]},
	{color: NITRATE_COLOR_SCALE_COLORS[18]},
	{color: NITRATE_COLOR_SCALE_COLORS[19]}
]
*/

export const LAYERS = {
	// borders
	'region_borders': {
		type: 'vtiles',
		tileserver: MBTILES_TILESERVER,
		tilesId: `denmark_adm_2`,
		zoom: {
			'minzoom': 2,
			'maxzoom': 10
		},
		layerType: 'line',
		paint: {
			'line-color': '#5f5f5f',
			'line-width': 0.5,
			'line-opacity': [
				'interpolate',
				['exponential', 0.5],
				['zoom'],
				6, 0.1,
				9, 0.4
			]
		},
		interactive: false,
		state: true,
		beforeLayer: 'settlement-subdivision-label'
	},
	/*
	'polygon_borders': {
		type: 'vtiles',
		tileserver: MBTILES_TILESERVER,
		tilesId: `vandoplande`,
		zoom: {
			'miDenmarkoom': 4,
			'maxzoom': 11
		},
		layerType: 'line',
		paint: {
			'line-color': 'black',
			'line-width': 0.5,
			'line-opacity': [
				'interpolate',
				['exponential', 0.5],
				['zoom'],
				6, 0.1,
				9, 0.4
			]
		},
		interactive: false,
		state: true,
		beforeLayer: 'region_borders'
	},
	*/

	// polygons
	'vandoplande': {
		type: 'vtiles',
		tileserver: MBTILES_TILESERVER,
		title: 'vandoplande',
		tilesId: `vandoplande`,
		zoom: {
			'minzoom': 4,
			'maxzoom': 11
		},
		layerType: 'fill',
		paint: {
			'fill-color': [
				'step',
				['coalesce', ['to-number', ['get', 'Nitrat']], -9999],
				// default for values < 1
				CONCENTRATION_LEVELS[0].color,
				CONCENTRATION_LEVELS[0].startValue, CONCENTRATION_LEVELS[0].color,
				CONCENTRATION_LEVELS[1].startValue, CONCENTRATION_LEVELS[1].color,
				CONCENTRATION_LEVELS[2].startValue, CONCENTRATION_LEVELS[2].color,
				CONCENTRATION_LEVELS[3].startValue, CONCENTRATION_LEVELS[3].color,
				CONCENTRATION_LEVELS[4].startValue, CONCENTRATION_LEVELS[4].color,
				CONCENTRATION_LEVELS[5].startValue, CONCENTRATION_LEVELS[5].color,
				CONCENTRATION_LEVELS[6].startValue, CONCENTRATION_LEVELS[6].color,
				CONCENTRATION_LEVELS[7].startValue, CONCENTRATION_LEVELS[7].color,
				CONCENTRATION_LEVELS[8].startValue, CONCENTRATION_LEVELS[8].color,
				CONCENTRATION_LEVELS[9].startValue, CONCENTRATION_LEVELS[9].color,
				/*
				NITRATE_COLOR_SCALE_COLORS[0],
				CONCENTRATION_LEVELS[1].startValue, NITRATE_COLOR_SCALE_COLORS[1],
				CONCENTRATION_LEVELS[2].startValue, NITRATE_COLOR_SCALE_COLORS[2],
				CONCENTRATION_LEVELS[3].startValue, NITRATE_COLOR_SCALE_COLORS[3],
				CONCENTRATION_LEVELS[4].startValue, NITRATE_COLOR_SCALE_COLORS[4],
				CONCENTRATION_LEVELS[5].startValue, NITRATE_COLOR_SCALE_COLORS[5],
				CONCENTRATION_LEVELS[6].startValue, NITRATE_COLOR_SCALE_COLORS[6],
				CONCENTRATION_LEVELS[7].startValue, NITRATE_COLOR_SCALE_COLORS[7],
				CONCENTRATION_LEVELS[8].startValue, NITRATE_COLOR_SCALE_COLORS[8],
				CONCENTRATION_LEVELS[9].startValue, NITRATE_COLOR_SCALE_COLORS[9],
				CONCENTRATION_LEVELS[10].startValue, NITRATE_COLOR_SCALE_COLORS[10],
				CONCENTRATION_LEVELS[11].startValue, NITRATE_COLOR_SCALE_COLORS[11],
				CONCENTRATION_LEVELS[12].startValue, NITRATE_COLOR_SCALE_COLORS[12],
				CONCENTRATION_LEVELS[13].startValue, NITRATE_COLOR_SCALE_COLORS[13],
				CONCENTRATION_LEVELS[14].startValue, NITRATE_COLOR_SCALE_COLORS[14],
				CONCENTRATION_LEVELS[15].startValue, NITRATE_COLOR_SCALE_COLORS[15],
				CONCENTRATION_LEVELS[16].startValue, NITRATE_COLOR_SCALE_COLORS[16],
				CONCENTRATION_LEVELS[17].startValue, NITRATE_COLOR_SCALE_COLORS[17],
				CONCENTRATION_LEVELS[18].startValue, NITRATE_COLOR_SCALE_COLORS[18],
				CONCENTRATION_LEVELS[19].startValue, NITRATE_COLOR_SCALE_COLORS[19]
				*/
			],
			'fill-opacity': [
				'case',
				['boolean', ['feature-state', 'selected'], false],
				1,
				0.7
			],
			'fill-outline-color': ['case',
				['boolean', ['feature-state', 'selected'], false],
				'#000000',
				'#c3c3c3'
			],
			
			/*[
				'case',
				['boolean', ['feature-state', 'selected'], false],
				'#000000',
				[
					'step',
					['coalesce', ['to-number', ['get', 'Nitrat']], -9999],
					CONCENTRATION_LEVELS[0].color,
					CONCENTRATION_LEVELS[0].startValue, CONCENTRATION_LEVELS[0].color,
					CONCENTRATION_LEVELS[1].startValue, CONCENTRATION_LEVELS[1].color,
					CONCENTRATION_LEVELS[2].startValue, CONCENTRATION_LEVELS[2].color,
					CONCENTRATION_LEVELS[3].startValue, CONCENTRATION_LEVELS[3].color,
					CONCENTRATION_LEVELS[4].startValue, CONCENTRATION_LEVELS[4].color,
					CONCENTRATION_LEVELS[5].startValue, CONCENTRATION_LEVELS[5].color,
					CONCENTRATION_LEVELS[6].startValue, CONCENTRATION_LEVELS[6].color,
					CONCENTRATION_LEVELS[7].startValue, CONCENTRATION_LEVELS[7].color,
					CONCENTRATION_LEVELS[8].startValue, CONCENTRATION_LEVELS[8].color,
					CONCENTRATION_LEVELS[9].startValue, CONCENTRATION_LEVELS[9].color,
				*/
					/*
					NITRATE_COLOR_SCALE_COLORS[0],
					CONCENTRATION_LEVELS[1].startValue, NITRATE_COLOR_SCALE_COLORS[1],
					CONCENTRATION_LEVELS[2].startValue, NITRATE_COLOR_SCALE_COLORS[2],
					CONCENTRATION_LEVELS[3].startValue, NITRATE_COLOR_SCALE_COLORS[3],
					CONCENTRATION_LEVELS[4].startValue, NITRATE_COLOR_SCALE_COLORS[4],
					CONCENTRATION_LEVELS[5].startValue, NITRATE_COLOR_SCALE_COLORS[5],
					CONCENTRATION_LEVELS[6].startValue, NITRATE_COLOR_SCALE_COLORS[6],
					CONCENTRATION_LEVELS[7].startValue, NITRATE_COLOR_SCALE_COLORS[7],
					CONCENTRATION_LEVELS[8].startValue, NITRATE_COLOR_SCALE_COLORS[8],
					CONCENTRATION_LEVELS[9].startValue, NITRATE_COLOR_SCALE_COLORS[9],
					CONCENTRATION_LEVELS[10].startValue, NITRATE_COLOR_SCALE_COLORS[10],
					CONCENTRATION_LEVELS[11].startValue, NITRATE_COLOR_SCALE_COLORS[11],
					CONCENTRATION_LEVELS[12].startValue, NITRATE_COLOR_SCALE_COLORS[12],
					CONCENTRATION_LEVELS[13].startValue, NITRATE_COLOR_SCALE_COLORS[13],
					CONCENTRATION_LEVELS[14].startValue, NITRATE_COLOR_SCALE_COLORS[14],
					CONCENTRATION_LEVELS[15].startValue, NITRATE_COLOR_SCALE_COLORS[15],
					CONCENTRATION_LEVELS[16].startValue, NITRATE_COLOR_SCALE_COLORS[16],
					CONCENTRATION_LEVELS[17].startValue, NITRATE_COLOR_SCALE_COLORS[17],
					CONCENTRATION_LEVELS[18].startValue, NITRATE_COLOR_SCALE_COLORS[18],
					CONCENTRATION_LEVELS[19].startValue, NITRATE_COLOR_SCALE_COLORS[19]
					*/
			//	]
			//],
			'fill-antialias': true
		},
		beforeLayer: 'region_borders',
		interactive: true,
		state: true
	},
};

export const LAYER_TYPE_COLUMN = 'layer';
export const LOCAL_STORAGE_TOKEN = 'gpdk-nitrate-disclaimer-hide';